import modalStyles from '@/components/Shares/Modal.module.css';
import { Container, Group, Image, Modal } from '@mantine/core';
import type { PropsWithChildren } from 'react';
import { Icons } from '../Shares/Icons';
export type AuthModalLayoutProps = PropsWithChildren & {
  opened: boolean;
  handleClose: () => void;
};
export const AuthModalLayout: React.FC<AuthModalLayoutProps> = ({
  opened,
  handleClose,
  children
}) => {
  return <Modal opened={opened} onClose={handleClose} closeButtonProps={{
    size: 37,
    bg: 'transparent',
    icon: <Icons className="icon-pr-line-close" fontSize={37} />
  }} overlayProps={{
    bg: 'rgba(23, 26, 30, 0.95)'
  }} size="100%" classNames={modalStyles}>
      <Group pos="absolute" bottom={0} left={0} right={0} justify="center">
        <Image src="/assets/character-body-bottom.png" alt="character" w={{
        base: 276,
        md: 382,
        lg: 357
      }} h={{
        base: 268,
        md: 370,
        lg: 254
      }} hiddenFrom="lg" />

        <Image src="/assets/bottom-character.svg" alt="character" w={{
        base: 276,
        md: 382,
        lg: 357
      }} h={{
        base: 268,
        md: 370,
        lg: 254
      }} visibleFrom="lg" />
      </Group>
      <Container px={0}>{children}</Container>
    </Modal>;
};